import fileDownload from 'js-file-download';
import {
	createDefaultFilename,
	getFilenameFromContentDisposition,
} from './filename-utility';

/**
 * Downloads a file from the api provided in the format provided
 * @param {*} param0
 * @returns
 */
export async function downloadFileFromApi({
	api,
	buildApiCall,
	executeApiCall,
	format,
	defaultFilenamePrefix,
	onError,
}) {
	try {
		const response = executeApiCall
			? await executeApiCall()
			: await api.call(buildApiCall());

		if (response.isAborted) {
			return false;
		}

		if (response.isError) {
			throw new Error(response.error?.message || 'Download failed');
		}

		const blob = response.data;

		const filename =
			getFilenameFromContentDisposition(
				response.headers?.contentDisposition ?? null
			) || createDefaultFilename(defaultFilenamePrefix, format);

		fileDownload(blob, filename);

		return true;
	} catch (err) {
		if (!onError) {
			throw err;
		}
		onError(err);
		return false;
	}
}
